import { styled } from 'twin.macro'
import * as styles from './styles'

export default styled.p(() => styles.base)
